module.exports = __webpack_public_path__ + "static/media/la-skyline-elysian-park.dc94cecc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/la-skyline-elysian-park.jpg
// module id = 384
// module chunks = 0